import {Component, DestroyRef, effect, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatDialog} from '@angular/material/dialog';
import {KtPaymentsFilterService} from '../service/kt-payments-filter.service';
import {KtPaymentsFilterModalComponent} from '../components/kt-payments-filter-modal/kt-payments-filter-modal.component';

@Component({
  selector: 'app-kt-payments',
  templateUrl: './kt-payments.component.html',
  standalone: false,
})
export class KtPaymentsComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly dialog = inject(MatDialog);
  private readonly filterService = inject(KtPaymentsFilterService);

  constructor() {
    effect(() => {
      const open = this.filterService.toggleModal();
      if (!open) return;
      const d = this.dialog.open(KtPaymentsFilterModalComponent, {width: '700px'});
      d.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.filterService.toggleModal.set(false);
      });
    });
  }
}
